module.exports = __webpack_public_path__ + "img/bottom_bar.d0e5922e.png";